import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../../components/table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultBody from "../../../components/table/ResultBody";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import EmptyLine from "../EmptyLine";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

// Culvert (RT3): RT 06 / RT 07 / RT 08, served by the dedicated
// `check_culvert_coeff` request.
export function RT3({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({row}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.RT06.error_id: {
            return (
                <>
                    <ResultText>
                        Culvert Entrance or Exit Loss Coefficient is not within the recommended (entrance 0.2-0.9, exit 0.3-1.0) limits for the following {row?.data?.length} culverts.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(10)}}>
                                    River Station
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(10)}}>
                                    Culvert
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                    Entrance
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                    Exit
                                </ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(x => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName csName={x.cross_section} csNameVal={x.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            {x.culvert_name}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', color: (x.entrance_coeff < 0.2 || x.entrance_coeff > 0.9) ? 'red' : ''}}>
                                            {x.entrance_coeff}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', color: (x.exit_coeff < 0.3 || x.exit_coeff > 1.0) ? 'red' : ''}}>
                                            {x.exit_coeff}
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.RT07.error_id: {
            return (
                <>
                    <ResultText>
                        Culvert Manning's n value is not within the recommended (0.010, 0.035) limits for the following {row?.data?.length} culverts.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(12)}}>
                                    River Station
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(10)}}>
                                    Culvert
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(18), textAlign: 'right'}}>
                                    Manning's n Top
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(18), textAlign: 'right'}}>
                                    Manning's n Bottom
                                </ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(x => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName csName={x.cross_section} csNameVal={x.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            {x.culvert_name}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', color: (x.mann_top < 0.010 || x.mann_top > 0.035) ? 'red' : ''}}>
                                            {x.mann_top}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', color: (x.mann_bottom < 0.010 || x.mann_bottom > 0.035) ? 'red' : ''}}>
                                            {x.mann_bottom}
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.RT08.error_id: {
            return (
                <>
                    <ResultText>
                        Weir Flow Coefficient is not within the recommended (2.5, 4.0) limits for the following {row?.data?.length} culverts.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(12)}}>
                                    River Station
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(10)}}>
                                    Culvert
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(20), textAlign: 'right'}}>
                                    Weir Flow Coefficient
                                </ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(x => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName csName={x.cross_section} csNameVal={x.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            {x.culvert_name}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', color: (x.weir_coef < 2.5 || x.weir_coef > 4.0) ? 'red' : ''}}>
                                            {x.weir_coef}
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}
